import { render, staticRenderFns } from "./PortCall.vue?vue&type=template&id=71734029&scoped=true"
import script from "./PortCall.vue?vue&type=script&lang=js"
export * from "./PortCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71734029",
  null
  
)

export default component.exports